export enum StudentAbsenceOrdering {
  Name,
  FromDate,
  ToDate,
}
